var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgLibrary = function SvgLibrary(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "library_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#library_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.248 8.314a9.196 9.196 0 0 0-.748 3.683c0 1.316.25 2.55.749 3.7a9.663 9.663 0 0 0 2.04 3.015c.86.86 1.868 1.54 3.026 2.039 1.157.5 2.385.749 3.685.749.213 0 .39-.072.534-.215a.725.725 0 0 0 .216-.535.726.726 0 0 0-.216-.534A.725.725 0 0 0 12 20c-2.217 0-4.104-.78-5.663-2.337C4.78 16.104 4 14.217 4 12s.78-4.104 2.337-5.663C7.896 4.78 9.783 4 12 4s4.104.78 5.663 2.337C19.22 7.896 20 9.783 20 12c0 .213.072.39.215.534a.725.725 0 0 0 .535.216c.212 0 .39-.072.534-.216A.725.725 0 0 0 21.5 12c0-1.3-.25-2.528-.75-3.685a9.627 9.627 0 0 0-2.038-3.027 9.663 9.663 0 0 0-3.016-2.039 9.185 9.185 0 0 0-3.7-.749c-1.3 0-2.527.25-3.682.748a9.628 9.628 0 0 0-3.026 2.04 9.628 9.628 0 0 0-2.04 3.026ZM14 16.988c0 .844.417 1.65 1.25 2.42s1.526 1.413 2.079 1.928a.47.47 0 0 0 .304.116c.109 0 .209-.038.3-.114.551-.5 1.242-1.144 2.072-1.932.83-.789 1.245-1.595 1.245-2.418 0-.542-.197-1.009-.59-1.4A1.926 1.926 0 0 0 19.252 15c-.325 0-.632.064-.923.192-.29.128-.525.305-.704.531a1.843 1.843 0 0 0-.7-.53 2.241 2.241 0 0 0-.927-.193c-.542 0-1.01.196-1.406.588a1.905 1.905 0 0 0-.592 1.4ZM14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-6.438-.747a4.504 4.504 0 0 1 3.691-3.691c.409-.069.747-.398.747-.812 0-.414-.338-.755-.748-.704a6.003 6.003 0 0 0-5.206 5.205c-.05.412.29.749.704.749s.743-.338.812-.747Z",
    fill: "currentColor"
  }))));
};
export default SvgLibrary;